import { EMPTY_ANA_INFO_MODEL } from 'presentation/model/ANAInforModel/ANAInfoModel';
import { useState } from 'react';
import { createContainer } from "react-tracked";

const {
    Provider: ANAInfoProvider,
    useTracked: useANAInfoTracked
} = createContainer(() => useState(EMPTY_ANA_INFO_MODEL), {concurrentMode: true});
export { ANAInfoProvider, useANAInfoTracked };
